import { render, staticRenderFns } from "./shop-assign-modal.vue?vue&type=template&id=89f2a776&scoped=true&"
import script from "./shop-assign-modal.vue?vue&type=script&lang=js&"
export * from "./shop-assign-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f2a776",
  null
  
)

export default component.exports